import * as _ from "lodash";
import { Fee } from "domain/fee";
import { getOfferTypeName, OfferTypeEnum } from "domain/offerType";
import { ContractType, getContractTypeName } from "domain/contract";
import Commodity from "domain/commodity";
import { CustomerWillSellText } from "common/formatters/useCustomerWillSellText";

const offerTypeOnly = new Set([OfferTypeEnum.FixBasisOnHta, OfferTypeEnum.FixFuturesOnBasis, OfferTypeEnum.BasisOffer]);

const None = "None";

export function getOfferContractTypeNamesForFee(fee: Fee): string {
    const types = _.uniq([
        ...fee.allowedOfferTypes.filter(m => offerTypeOnly.has(m)).map(getOfferTypeName),
        ...fee.allowedContractTypes.map(getContractTypeName)
    ]);

    return types.length > 0
        ? types.join(', ')
        : None;
}

export function getCommodityNamesForFee(fee: Fee, commodities: Commodity[]): string {
    const names = commodities.filter(m => fee.allowedCommodities.includes(m.id))
        .map(m => m.name);

    return names.length > 0
        ? names.join(', ')
        : None;
}

export function getBuySellForFee(fee: Fee, customerWillSellText: CustomerWillSellText): string {
    return fee.allowPurchase
        ? fee.allowSale ? "Both" : customerWillSellText.formatValue(false)
        : fee.allowSale ? customerWillSellText.formatValue(true) : None;
}

export function listAllowedFees(fees: Fee[], customerWillSell: boolean, commodity: Commodity, contractType: ContractType, offerType?: OfferTypeEnum): Fee[] {
    if (fees == null || fees.length === 0 || commodity == null) return [];

    return fees.filter(f => ((customerWillSell && f.allowSale) || (!customerWillSell && f.allowPurchase)) &&
        f.allowedCommodities.includes(commodity.id) && !f.isReadOnly &&
        (f.allowedOfferTypes.includes(offerType) || f.allowedContractTypes.includes(contractType)));
}